<template>
  <div class="box-simulator">
    <h3 class="maintitle">Simula tu inversión</h3>
    <div class="simulator-fields">
      <div class="box-field rate">
        <span class="title">Tasa</span>
        <span class="value">{{ formatPercentage(rate) }}</span>
      </div>
      <transition name="component-fade" mode="in-out">
        <div>
          <div class="box-field amountmaximum">
            <span class="title">Monto máximo</span>
            <span class="value">{{ formatCurrency(maximumAmountToInvest) }}</span>
          </div>
          <div v-if="simulationStatus === false && status === 'open'">
            <div class="box-field-split clearfix -noseparation">
              <div class="box-field amountToInvestTitle">
                <span class="title -fullwidth">Monto a invertir</span>
              </div>
              <div class="box-field amountToInvest" v-if="simulationOtherAmount === false">
                <span
                  class="value -fullwidth"
                  v-if="simulationConditions(amountToInvest).zero['status']">
                  {{ formatCurrency(0) }}
                </span>
                <span class="value -fullwidth" v-else>
                  {{ formatCurrency(amountToInvest) }}
                </span>
              </div>
              <div class="box-field amountToInvest otherAmountInvestInput" v-else>
                <money v-model="amountToInvest" v-bind="money"></money>
              </div>
            </div>
            <div
              class="box-field amountmaximum"
              v-if="simulationConditions(amountToInvest).above['status']
              && simulationConditions(amountToInvest).equal['status'] === false">
              <div class="-widthinvestslider">
                <vue-slider
                  class="investslider"
                  v-bind="slider"
                  :value="amountToInvest"
                  :min="minimumAmountToInvest"
                  :max="maximumAmountToInvest"
                  @callback="val => amountToInvest = val">
                </vue-slider>
              </div>
            </div>
            <transition name="fade">
              <div
                class="box-field otherAmountInvestLink -noborder -centered-info"
                v-if="amountToInvest < (maximumAmountToInvest)
                && (maximumAmountToInvest) !== 0
                && simulationOtherAmount === false">
                <a href="#" @click.prevent="simulationOtherAmount = true">
                  <h3><b>Ingresa otro monto a invertir aquí</b></h3>
                </a>
              </div>
            </transition>
            <transition name="fade">
              <div class="box-field -noborder"
                v-if="amountToInvest > (maximumAmountToInvest)
                && (maximumAmountToInvest) !== 0">
                <p class="message">
                  El monto a invertir no puede ser superior al monto máximo de
                  {{ formatCurrency(maximumAmountToInvest) }}
                </p>
              </div>
            </transition>
            <transition name="fade">
              <div class="box-field -noborder" v-if="amountToInvest < 1000">
                <p class="message">
                  El monto a invertir no puede ser menor a $1,000.00
                </p>
              </div>
            </transition>
            <transition name="fade">
              <div class="box-field -noborder"
                v-if="!simulationConditions(amountToInvest).multiple['status']">
                <p class="message">
                  El monto a invertir debe ser múltiplo de 100
                </p>
              </div>
            </transition>
            <div class="box-field sendinvestment -noborder">
              <button
                class="button button-large -fullwidth"
                @click="calculateSimulation()"
                  :disabled="!simulationConditions(amountToInvest).multiple['status']
                  || amountToInvest > (maximumAmountToInvest)
                  || amountToInvest === 0
                  || this.status === 'closed'
                  || simulationConditions(amountToInvest).below['status']
                ">
                Simular inversión
              </button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="component-fade" mode="in-out">
        <div v-if="simulationStatus">
          <div class="simulator-result">
            <div class="box-field amountinvestment">
              <span class="title">Monto inversión</span>
              <span class="value">{{ formatCurrency(amountToInvest) }}</span>
            </div>
            <div class="box-field cumplopoints">
              <span class="title">Utilidad bruta</span>
              <span class="value">
                {{ formatCurrency(simulatedInstallment - amountToInvest) }}
              </span>
            </div>
            <div class="box-field totaltransfer -noborder">
              <span class="title">Monto a transferir</span>
              <span class="value">{{ formatCurrency(simulatedNetInvestment) }}</span>
            </div>
          </div>
          <div class="box-field -noborder">
            <button class="button button-clear -fullwidth"
              @click="newSimulation()">Volver a simular
            </button>
          </div>
          <div class="button-invest">
            <button class="button button-large button-action -fullwidth"
              @click.prevent="$modal.show('want-to-invest')" :disabled="this.status === 'closed'">
              Ver detalle de inversión
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

import Preloader from '@/components/Preloader'

import Vue from 'vue'
import money from 'v-money'
import vueSlider from 'vue-slider-component'
import mixins from '@/mixins/index'

Vue.use(money)

export default {
  name: 'Simulator',
  data () {
    return {
      maximumAmountToInvest: this.amountRequested - this.amountFinanced,
      minimumAmountToInvest: 1000,
      amountToInvest: 1000,
      amountFromComparison: this.$store.getters.getCreditCompareAmountSelect,
      simulatedNetInvestment: 0,
      simulatedInstallment: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 0,
        masked: false
      },
      slider: {
        value: 1000,
        interval: 100,
        min: 1000,
        dotSize: 25,
        debug: false,
        formatter: function (value) {
          return 'Desliza'
        },
        'tooltip-dir': 'left',
        tooltipStyle: {
          'backgroundColor': '#00874b',
          'borderColor': '#00874b',
          'fontSize': '12px'
        },
        processStyle: {
          'backgroundColor': '#00874b'
        },
        sliderStyle: {
          'backgroundColor': '#00ba68'
        },
        bgStyle: {
          'backgroundColor': '#ffffff'
        }
      },
      simulationStatus: false,
      simulationOtherAmount: false
    }
  },
  components: {
    Preloader,
    vueSlider
  },
  props: {
    'rate': Number,
    'duration': Number,
    'amountRequested': Number,
    'amountFinanced': Number,
    'status': String
  },
  mixins: [mixins],
  methods: {
    calculateSimulation: function () {
      const upfrontDailyFee = 0.00 / 100 * 1.16
      const collectionDailyFee = 0.2 / 100 / 30 * 1.16

      const tmpSimulatedInstallment = (this.amountToInvest *
        (1 + this.rate / 100 / 360 * this.duration))
      const tmpSimulatedCollectionFee = (collectionDailyFee *
        this.duration * this.amountToInvest)
      const tmpSimulatedNetInstallment = (tmpSimulatedInstallment -
        tmpSimulatedCollectionFee)
      const tmpSimulatedUpfrontFee = (upfrontDailyFee * this.duration *
        this.amountToInvest)
      const tmpSimulatedNetInvestment = (this.amountToInvest +
        tmpSimulatedUpfrontFee)

      this.simulatedInstallment = (Math.round(
        tmpSimulatedInstallment * 100) / 100)
      const simulatedNetInstallment = Math.round(
        tmpSimulatedNetInstallment * 100) / 100
      this.simulatedNetInvestment = Math.round(
        tmpSimulatedNetInvestment * 100) / 100
      const simulatedUpfrontFee = Math.round(
        tmpSimulatedUpfrontFee * 100) / 100
      const simulatedCollectionFee = Math.round(
        tmpSimulatedCollectionFee * 100) / 100

      this.simulationStatus = true

      const storedValues = {
        amountInvest: this.amountToInvest,
        simulatedInstallment: this.simulatedInstallment,
        simulatedNetInvestment: this.simulatedNetInvestment,
        simulatedUpfrontFee: simulatedUpfrontFee,
        simulatedCollectionFee: simulatedCollectionFee,
        simulatedNetInstallment: simulatedNetInstallment
      }

      this.$store.dispatch('simulatedValues', storedValues)
    },
    newSimulation: function () {
      this.simulationStatus = !this.simulationStatus
    },
    simulationConditions: function (currentAmount) {
      return {
        'zero': {
          'status': this.maximumAmountToInvest === 0
        },
        'below': {
          'status': (this.amountToInvest > this.maximumAmountToInvest ||
          this.amountToInvest < this.minimumAmountToInvest)
        },
        'equal': {
          'status': this.maximumAmountToInvest === this.minimumAmountToInvest
        },
        'above': {
          'status': (this.amountToInvest > this.minimumAmountToInvest ||
          this.amountToInvest < this.maximumAmountToInvest)
        },
        'multiple': {
          'status': parseInt(this.amountToInvest, 10) % 100 === 0
        }
      }
    }
  },
  created: function () {
    if (this.amountFromComparison !== 0 && this.amountFromComparison <=
      this.maximumAmountToInvest) {
      this.amountToInvest = this.amountFromComparison
    }
  }
}

</script>

<style lang="scss" scoped>

.box-simulator {
  background-color: $midnight-blue;
  color: $white;

  .maintitle {
    text-align: center;
    font-weight: 300;
    font-size: 1.2em;
  }
}

.box-field {
  $width: 48%;

  padding: .7rem 0;

  &:not(.-noborder) {
    border-bottom: 1px solid rgba(255, 255, 255, .2);
  }

  .message {
    margin: 0;
    padding: .3rem .4rem;
    background-color: #EF0000;
    color: #fff;
    font-size: .75em;
    border-radius: 3px;
  }

  .title {
    display: inline-block;
    width: $width;
    font-size: .8em;
  }

  .value {
    display: inline-block;
    width: $width;
    margin-left: 2%;
    font-weight: bold;
    text-align: right;
    font-size: 1em;
  }

  .-fullwidth {
    width: 100%;
  }
}

.-widthinvestslider {
  width: 80%;
  margin: 0 auto;

  @media (min-width: 42rem) {
    width: 100%;
  }
}

.box-field-split {

  .box-field {
    width: 47%;
    float: left;

    &:nth-of-type(even) {
      margin-left: 6%;
    }

    .title, .value {
      margin-left: 0;
    }
  }

  &.-noseparation {

    .box-field {
      width: 50%;
      margin: 0;
    }
  }
}

.sendinvestment {
  padding: 2rem 0;
  text-align: center;
}

.amountToInvest,
.amountToInvestTitle {
  background-color: #1F262B;
}
.amountToInvestTitle > .title {
  padding-left: .5rem;
}
.amountToInvest > .value {
  padding-right: .5rem;
}

.amountToInvestInput {
  height: auto;
  margin: 0;
  padding: 0 .6rem 0;
  border: 0;
  color: $white;
  font-size: 1em;
  text-align: right;
  font-weight: bold;
}

.otherAmountInvestLink > a {
  font-size: .8em;
  color: $yellow;
}

.otherAmountInvestInput {
  padding: 0;

  .v-money {
    margin: 0;
    padding: .5rem;
    background-color: $white;
    color: $midnight-blue;
    text-align: right;
    font-size: 1em;
    font-family: inherit;
    font-weight: bold;
    border-radius: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/requestDetail/RequestDetailSimulator.vue